import React from 'react';
import PropTypes from 'prop-types';

import vsImage from 'images/payment/VS_image.png';
import mcImage from 'images/payment/MC_image.png';
import dsImage from 'images/payment/5_DS.jpg';
import dcImage from 'images/payment/5_DC.jpg';
import jsImage from 'images/payment/5_JC.jpg';
import maImage from 'images/payment/5_MA.jpg';


function PaymentMethodIcon({ prefixedIcon, className }) {
  if (!prefixedIcon) {
    return null;
  }

  const idExists =
    prefixedIcon.processorId !== undefined &&
    prefixedIcon.methodType !== undefined;
  const path =
    idExists ? `${prefixedIcon.processorId}_${prefixedIcon.methodType}` : `${prefixedIcon.processorId}`;

  if (prefixedIcon?.methodType === 'CC') {
    return (
      <div className={className}>
        <img alt="payment" className={className} src={vsImage} />
        <img alt="payment" className={className} src={mcImage} />
        <img alt="payment" className={className} src={dsImage} />
        <img alt="payment" className={className} src={dcImage} />
        <img alt="payment" className={className} src={jsImage} />
        <img alt="payment" className={className} src={maImage} />
      </div>
    );
  }

  return (
    <img alt="payment" className={className} src={require(`images/payment/${path}.jpg`)} />
  );
}

PaymentMethodIcon.propTypes = {
  className: PropTypes.string,
  prefixedIcon: PropTypes.PropTypes.shape({
    methodType: PropTypes.string,
    processorId: PropTypes.number,
  }),
};

PaymentMethodIcon.defaultProps = {
  className: undefined,
  prefixedIcon: undefined,
};

export default PaymentMethodIcon;
